export default {
    FETCH_TERMS_PAGES(state, response) {
        if(response.status == 200) {
            state.pages = response.data.pages;
        }
    },
    TERMS_CONTENT(state, response) {
        if(response.status == 200) {
            state.termsTitle = response.data.page.title;
            state.termsContent = response.data.page.content;
        }
    },
    CLEAR_TERMS_CONTENT(state) {
        state.termsTitle = '';
        state.termsContent = '';
    },
    FAQS(state, response) {
        if(response.status == 200) {
            state.categories = response.data.categories;
        }
    }
}